



import { Component, Vue, Watch } from "vue-property-decorator";
import UserOnline from "@/app/components/userOnline/userOnline.component.vue";

@Component({
  name: "sidebar-userlist",
  components: { UserOnline },
})
export default class SidebarUserListComponent extends Vue {
  search = "";
  loading = false;
  searchTimeOut = null;
  sidebarFull(): boolean {
    return this.$store.getters["SidebarStore/getSidebarFull"];
  }

  unSeenMessage(user): boolean {
    return (
      this.$store.getters["ChatStore/getUnSeenMessage"].filter(
        (a) => a === user.id
      ).length > 0
    );
  }
}
